import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { shareReplay, switchMap } from 'rxjs/operators';
import { Setting } from './setting';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

    constructor(private http: HttpClient) { }

    private readonly routePrefix: string = '/api/setting';

    private galleryHeaderImageRefresh: BehaviorSubject<void> = new BehaviorSubject<void>(undefined);
    private schoolLogoImageRefresh: BehaviorSubject<void> = new BehaviorSubject<void>(undefined);

    galleryHeaderImageURI$ = this.galleryHeaderImageRefresh.pipe(
        switchMap(() => this.http.get<string>(`${this.routePrefix}/galleryheader`)),
        shareReplay(1)
    );

    schoolLogoImageURI$ = this.schoolLogoImageRefresh.pipe(
        switchMap(() => this.http.get<string>(`${this.routePrefix}/schoollogo`)),
        shareReplay(1)
    );

    getAllInternal = () => this.http.get<Setting[]>(`${this.routePrefix}/internal`);

    getAllBasicSettings = () => this.http.get<Setting[]>(`${this.routePrefix}/basic`);

    getProductUrl = () => this.http.get<string>(`${this.routePrefix}/producturl`).pipe(
        shareReplay(1)
    )

    update = (settings: Setting[]) => this.http.post(this.routePrefix, settings);

    setImageSetting(blob: Blob, imageSettingName: string) {
        const subject = new Subject();

        this.http.post(`${this.routePrefix}/imagesetting`, blob, {
            headers: new HttpHeaders({
                ['Content-Disposition']: 'attachment'
            }),
            params: new HttpParams().set('imageSettingName', imageSettingName)
        })
        .subscribe(
            response => {
                const reader = new FileReader();

                reader.readAsDataURL(blob);

                subject.next(response);
                subject.complete();
            },
            error => { subject.error(error); }
        );

        return subject;
    }

    deleteImageSetting = (imageSettingName: string) =>
        this.http.delete(`${this.routePrefix}/imagesetting`, {
            params: new HttpParams().set('imageSettingName', imageSettingName)
        })

    refreshGalleryHeaderImageURI(): void {
        this.galleryHeaderImageRefresh.next();
    }

    refreshSchoolLogoImageURI(): void {
        this.schoolLogoImageRefresh.next();
    }
}
